import React, {useMemo, useState} from "react"
import {useParams} from "react-router-dom"
import {Layout} from "../Layout"
import {useSirenAlertStatus, useSirenDeliveryAttempts, useSirenResponses, useSirenBreakdown} from "../hooks/useSirenAlertWS"
import {AlertInfoCard} from "./AlertInfoCard"
import {ResponsesCard} from "./ResponsesCard"
import {DeliveryBreakdownCard} from "./DeliveryBreakdownCard"
import {DeliveryAttemptsCard} from "./DeliveryAttemptsCard"

export function AlertStatus() {
    const {id} = useParams<{id: string}>()

    const {snapshot, state, connected, nextCycleAt} = useSirenAlertStatus(id)
    const {data: attemptsData} = useSirenDeliveryAttempts(id)
    const {data: responsesData} = useSirenResponses(id)
    const {data: breakdownData} = useSirenBreakdown(id)

    // Derive all known cycles from all 3 stat sources.
    const allCycles = useMemo(() => {
        const cycleSet = new Set<number>()
        attemptsData?.attempts.forEach(a => cycleSet.add(a.cycle))
        responsesData?.cycles.forEach(c => cycleSet.add(c.cycle))
        breakdownData?.categories.forEach(c => cycleSet.add(c.cycle))
        return [...cycleSet].sort((a, b) => a - b)
    }, [attemptsData, responsesData, breakdownData])

    // Default to "all" (or switch to current cycle when in_progress and only one cycle known).
    const [selectedCycle, setSelectedCycle] = useState<number | "all">("all")

    const alert = snapshot?.alert ?? null

    if (!alert) {
        return (
            <Layout menuCurrent="alert">
                <div className="flex items-center justify-center h-48 text-grey text-sm">
                    {connected ? "Loading…" : "Connecting…"}
                </div>
            </Layout>
        )
    }

    return (
        <Layout menuCurrent="alert">
            <div className="flex flex-col gap-5">

                <div className="grid grid-cols-1 xl:grid-cols-2 gap-5">
                    <AlertInfoCard
                        alertID={id!}
                        snapshot={snapshot}
                        state={state}
                        connected={connected}
                        nextCycleAt={nextCycleAt}
                        onCancel={() => {}}
                    />

                    {(alert.responseOptions ?? []).length > 0 ? (
                        <ResponsesCard
                            alertID={id!}
                            responseOptions={alert.responseOptions ?? []}
                            selectedCycle={selectedCycle}
                            onCycleChange={setSelectedCycle}
                        />
                    ) : (
                        <DeliveryBreakdownCard
                            alertID={id!}
                            alert={alert}
                            state={state}
                            selectedCycle={selectedCycle}
                            onCycleChange={setSelectedCycle}
                        />
                    )}

                    {(alert.responseOptions ?? []).length > 0 && (
                        <DeliveryBreakdownCard
                            alertID={id!}
                            alert={alert}
                            state={state}
                            selectedCycle={selectedCycle}
                            onCycleChange={setSelectedCycle}
                        />
                    )}

                    <DeliveryAttemptsCard
                        alertID={id!}
                        alert={alert}
                        state={state}
                        selectedCycle={selectedCycle}
                        onCycleChange={setSelectedCycle}
                    />
                </div>

            </div>
        </Layout>
    )
}
